import { useState } from "react";
import axios from "axios";
import { SERVICEURL } from "../../appconfig";
import { PositionDifficultyLevelGuids } from "../../constants/parameterGuids";

/** UpdatePositionDifficulty API request body */
export interface UpdatePositionDifficultyRequest {
  id: string;
  positionId: string;
  difficultyId: string;
  difficultyLvlId?: string | null;
}

/** Seçilen zorluk seviyesine göre API difficultyLvlId değeri */
export const DIFFICULTY_LVL_ID: Record<"Yüksek" | "Orta", string> = {
  Yüksek: PositionDifficultyLevelGuids.high,
  Orta: PositionDifficultyLevelGuids.medium,
};

interface UpdatePositionDifficultyResponse {
  code?: number;
  message?: string;
  data?: string;
}

export const useUpdatePositionDifficulty = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const updatePositionDifficulty = async (
    body: UpdatePositionDifficultyRequest,
  ): Promise<boolean> => {
    try {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem("token");
      const response = await axios.put<UpdatePositionDifficultyResponse>(
        `${SERVICEURL}api/Position/UpdatePositionDifficulty`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const ok = response.status >= 200 && response.status < 300;
      const code = response.data?.code;
      const codeOk = code === undefined || code === 0 || code === 200;
      return ok && codeOk;
    } catch (err: any) {
      const errObj = err instanceof Error ? err : new Error(err?.message || "Unknown error");
      setError(errObj);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { updatePositionDifficulty, loading, error };
};
